import { TagEventsEnum } from 'common/enums/TagEventsEnum'
import BaseBridge from 'config/bridge/BaseBridge'

export const analyticsRedeemValueTag = () => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    screen: 'resgate saldo',
    ref_figma: '80',
    ref_type: 'botao',
    content_action: 'toque',
    action_id: 'Concluir resgate',
    product: 'capitalização',
    flow: 'resgate',
  })
}

export const analyticsBSAcceptTag = () => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    screen: 'bottom sheet oportunidade',
    ref_figma: '81',
    ref_type: 'botao',
    content_action: 'toque',
    action_id: 'aproveitar',
    product: 'capitalização',
    flow: 'resgate',
  })
}
export const analyticsBSDismissTag = () => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    screen: 'bottom sheet oportunidade',
    ref_figma: '82',
    ref_type: 'botao',
    content_action: 'toque',
    action_id: 'continuar com o resgate',
    product: 'capitalização',
    flow: 'resgate',
  })
}

export const analyticsRedeemLoad = (params?: Record<string, string>) => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    screen_name: 'Sortezinha:Resgatar',
    product_area: 'Resgate',
    section: 'Resgate',
    product: 'capitalização',
    step: '2',
    flow: 'prateleira',
    ...params,
  })
}

export const analyticsRepurchaseBottomSheetDisplay = (params?: Record<string, string>) => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    screen_name: 'Sortezinha:Resgatar',
    product_area: 'Resgate',
    section: 'Resgate',
    product: 'capitalização',
    step: '3',
    flow: 'prateleira',
    ...params,
  })
}
